import type { PropRule } from './analytics-types.js';

export function clickFrictionEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  return {
    button_rage_click_detected: { ...common, target: new Set(['button']), control: /^[0-9.]{1,100}$/ },
    suspected_dead_click: { ...common, target: new Set(['button', 'page']), control: /^[0-9.]{1,100}$/ },
  };
}
